export const api = {
    base:"https://nuvola40apinew.azurewebsites.net",
    storageBase:"https://nuvolastorageprod.blob.core.windows.net",
    arcadLab: 'https://nuvola.arcadlab.com',
    googleMapsApiKey: 'AIzaSyCXd8NdNkkBF1MvJWCwWIB4PQmmsOsv9DI'
};
